import { PortalApiError } from './api';
import { ERROR_CODE_ALREADY_IN_MEETING, ERROR_CODE_DEVICE_LIMIT_EXCEEDED } from './constants';
import logger from './logger';
import { PortalMessages as M } from './messages';
/**
 * 用户确认后追加当前设备；取消则返回 undefined。
 */
export async function withDeviceJoinPrompt(action) {
    try {
        return await action();
    }
    catch (error) {
        if (!(error instanceof PortalApiError)) {
            throw error;
        }
        if (error.code === ERROR_CODE_DEVICE_LIMIT_EXCEEDED) {
            logger.info(`[门户] ${new Date().toISOString()} 并发设备已满 | open=${error.openDeviceCount}`
                + ` max=${error.maxConcurrentDevices}`);
            window.alert(error.message || M.DEVICE_LIMIT_EXCEEDED);
            return undefined;
        }
        if (error.code !== ERROR_CODE_ALREADY_IN_MEETING) {
            throw error;
        }
        logger.info(`[门户] ${new Date().toISOString()} 已在其他设备入会，询问是否添加当前设备`
            + ` | open=${error.openDeviceCount} max=${error.maxConcurrentDevices}`);
        const confirmed = window.confirm(M.ADD_CURRENT_DEVICE_CONFIRM);
        if (!confirmed) {
            logger.info(`[门户] ${new Date().toISOString()} 用户取消添加当前设备`);
            return undefined;
        }
        try {
            return await action({ addDevice: true });
        }
        catch (retryError) {
            if (retryError instanceof PortalApiError
                && retryError.code === ERROR_CODE_DEVICE_LIMIT_EXCEEDED) {
                window.alert(retryError.message || M.DEVICE_LIMIT_EXCEEDED);
                return undefined;
            }
            throw retryError;
        }
    }
}
